<template>
  <div>
    <div class="dropdown">
      <input
        type="text"
        class="form-control"
        v-model="typed"
        @click="clickInput"
        @keyup.enter="enterInput"
      />
      <span data-bs-toggle="dropdown" ref="el"></span>
      <ul class="dropdown-menu w-100">
        <li v-for="t in filteredCandidates" :key="t">
          <a
            href="javascript:0"
            class="dropdown-item small"
            @click="select(t)"
            v-html="t.replace(typed, `<b>${typed}</b>`)"
          >
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as bootstrap from "bootstrap";
const eventName = "change";
const eventSource = "selected";

export default {
  name: "EpiSelect",
  props: [eventSource, "candidates", "placeholder", "noBorder"],
  model: {
    prop: eventSource,
    event: eventName,
  },
  data() {
    return {
      dropdownMenu: null,
      typed: "",
    };
  },
  computed: {
    _selected: {
      get() {
        return this[eventSource];
      },
      set(v) {
        this.$emit(eventName, v);
      },
    },
    filteredCandidates() {
      if (this.typed.length === 0) return this.candidates;
      return this.candidates.filter((a) => a.includes(this.typed));
    },
  },
  methods: {
    clickInput(e) {
      e.stopPropagation();
      this.dropdownMenu.show();
    },
    enterInput() {
      this._selected = this.typed;
    },
    select(t) {
      this.typed = t;
      this._selected = this.typed;
    },
  },
  mounted() {
    this.dropdownMenu = new bootstrap.Dropdown(this.$refs.el);
  },
};
</script>

<style lang="stylus" scoped>
.dropdown-menu
  max-height 250px
  overflow-y auto
</style>
